import React, { useState, useEffect, useRef } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { useDemandServiceListController } from 'src/controllers/DemandService/ListDemandServiceController';
import PrintDemand from '../../controllers/Demands/PrintDemand';
import { ModelOfDemand } from 'src/database';
import DemandController from '../../controllers/Demands/DemandController';
import { Checkbox, CheckboxChangeParams } from "primereact/checkbox";

import EditDemand from './EditDemand';
import { useAuth } from 'src/contexts/auth';
import { Tooltip } from 'primereact/tooltip';
import { AutoComplete, AutoCompleteCompleteMethodParams } from 'primereact/autocomplete';
import moment from 'moment';

interface Props {
    ID: string;
    ORGAO: string;
    NOME_ORGAO: string;
    DESCRICAO: string;
    PESSOAORIGEM: string;
    NOME_PESSOAORIGEM: string;
    PESSOADESTINO: string;
    NOME_PESSOADESTINO: string;
    ORGAOUNIDADEDESTINO: string;
    NOME_ORGAOUNIDADEDESTINO: string;
    DATA: string;
    PRIORIDADE: string;
    DESCRICAO_PRIORIDADE: string;
    TIPODEMANDA: number;
    FT_USUARIO: string;
    ID_CELULAR: string;
    STATUS: number;
    FT_MOTORISTA: string;
    FT_VEICULO: string;
    NOME_VEICULO: string;
}

const ReceivedDemandsList = () => {
    let emptyProduct: Props = {
        ID: '',
        ORGAO: '',
        NOME_ORGAO: '',
        DESCRICAO: '',
        PESSOAORIGEM: '',
        NOME_PESSOAORIGEM: '',
        PESSOADESTINO: '',
        NOME_PESSOADESTINO: '',
        ORGAOUNIDADEDESTINO: '',
        NOME_ORGAOUNIDADEDESTINO: '',
        DATA: '',
        PRIORIDADE: '',
        DESCRICAO_PRIORIDADE: '',
        TIPODEMANDA: 0,
        FT_USUARIO: '',
        ID_CELULAR: '',
        STATUS: -1,
        FT_MOTORISTA: '',
        FT_VEICULO: '',
        NOME_VEICULO: '',
    };

    interface Veiculo {
        label: string;
        value?: string;
    }

    const [products, setProducts] = useState<ModelOfDemand[]>();
    const [productsAux, setProductsAux] = useState<ModelOfDemand[]>();
    const [deleteProductDialog, setDeleteProductDialog] = useState(false);
    const [rejectDemandDialog, setRejectDemandDialog] = useState(false);
    // const [deleteProductsDialog, setDeleteProductsDialog] = useState(false);
    const [product, setProduct] = useState(emptyProduct);
    const [selectedProducts, setSelectedProducts] = useState(null);
    const [globalFilter, setGlobalFilter] = useState(null);
    // const [globalFilterValue, setGlobalFilterValue] = useState('');

    const dt = useRef(null);

    const { getDemandListController, handleDemandListController } = useDemandServiceListController();
    const { saldoAbastecimentos, vehicles } = getDemandListController;
    const { setSaldoAbastecimentos } = handleDemandListController;
    const { setDialogDemand, setDemand, dialogDemand, setAuthDemand } = useAuth();

    const { getDemandData } = DemandController();
    const { deleteDemand, toast, rejectDemandAdmin } = getDemandData;
    const { printCall } = PrintDemand();
    const { sendToPrint, toastPrint } = printCall;

    const updateDemands = dialogDemand === false ? true : false;

    //// VEICULO
    const [valueVehicle, setValueVehicle] = useState('');
    const [selectedVeiculo, setSelectedVeiculo] = useState<Veiculo | null>(null);
    const [filteredVeiculo, setFilteredVeiculo] = useState<Veiculo[]>([]);
    const veiculos: Veiculo[] = [...vehicles];
    const searchVeiculo = (event: AutoCompleteCompleteMethodParams) => {
        const query = event.query.toLowerCase();
        const results = veiculos.filter(veiculo =>
            veiculo.label.toLowerCase().includes(query)
        );
        setFilteredVeiculo(results);
    };

    useEffect(() => {
        getDemandListController.getDemandsOrderServices();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [updateDemands]);

    useEffect(() => {
        setProducts(getDemandListController.demandsData);
        setProductsAux(getDemandListController.demandsData);
        console.log("demandsData recebida: ", getDemandListController.demandsData)
    }, [getDemandListController.demandsData]); // eslint-disable-line react-hooks/exhaustive-deps

    function sortByDate(a: any, b: any) {
        if (a.DATA < b.DATA) {
            return 1;
        }
        if (a.DATA > b.DATA) {
            return -1;
        }
        return 0;
    }

    if (getDemandListController.demandsData.length) {
        getDemandListController.demandsData.sort(sortByDate);
    }

    const hideDeleteProductDialog = () => {
        setDeleteProductDialog(false);
    };

    const hideRejectDemandDialog = () => {
        setRejectDemandDialog(false);
    };

    const confirmDeleteProduct = (product: Props) => {
        console.log("   <---- product:  ----> ",product)
        setProduct(product);
        setDeleteProductDialog(true);
    };

    const confirmRejectDemand = (product: Props) => {
        setProduct(product);
        setRejectDemandDialog(true);
    };

    const deleteProduct = () => {
        let _products = products?.filter(val => val.ID !== product.ID);
        deleteDemand(product.ID);
        setProducts(_products);
        setDeleteProductDialog(false);
        setProduct(emptyProduct);
    };

    const rejectDemand = () => {
        let _products = products?.filter(val => val.ID !== product.ID);
        rejectDemandAdmin(product);
        setRejectDemandDialog(false);
        setProducts(_products);
        setProduct(emptyProduct);
    };

    const typeOfDemandaBodyTemplate = (rowData: { TIPODEMANDA: number | undefined }) => {
        let typeOfDemanda;
        if (rowData.TIPODEMANDA === 0) {
            typeOfDemanda = 'Combustível';
        }
        if (rowData.TIPODEMANDA === 1) {
            typeOfDemanda = 'Serviço';
        }
        return <span>{typeOfDemanda}</span>;
    };

    // const statuses = [
    //     { label: 'Em aberto', value: -1 },
    //     { label: 'Autorizada', value: 0 },
    //     { label: 'Cancelada', value: 1 },
    // ];

    const dateBodyTemplate = (rowData: { DATA: any | undefined }) => {
        const dataTexto = rowData.DATA.toString();
        let date: any = new Date(dataTexto);
        date = date.toLocaleDateString('pt-BR');

        return <span>{date}</span>;
    };

    const dateInicioBodyTemplate = (rowData: { DATAINICIO: any | undefined }) => {
        if (rowData.DATAINICIO != null) {
            const dataTexto = rowData.DATAINICIO.toString();
            let date: any = new Date(dataTexto);
            date = date.toLocaleDateString('pt-BR');

            return <span>{date}</span>;
        } else {
            return <span></span>;
        }
    };

    const dateFimBodyTemplate = (rowData: { DATAFIM: any | undefined }) => {
        if (rowData.DATAFIM != null) {
            const dataTexto = rowData.DATAFIM.toString();
            let date: any = new Date(dataTexto);
            date = date.toLocaleDateString('pt-BR');

            return <span>{date}</span>;
        } else {
            return <span></span>;
        }
    };

    const statusBodyTemplate = (rowData: { STATUS: {} | null | undefined }) => {
        let status;
        let textStyle;

        if (rowData.STATUS === -1 || rowData.STATUS === null) {
            status = 'Em aberto';
            textStyle = 'alert-message';
        }
        if (rowData.STATUS === 0) {
            status = 'Autorizada';
            textStyle = 'sucess-message';
        }
        if (rowData.STATUS === 1) {
            status = 'Cancelada';
            textStyle = 'warning-message';
        }
        return <span className={`tags ${textStyle}`}>{status}</span>;
    };

    const editProduct = (rowData: any) => {
        console.log("rowData produtos: ", rowData)
        // Convertendo DATAINICIO para o formato dd/MM/yyyy
        const formattedDateInicio = moment(rowData.DATAINICIO).format("DD/MM/YYYY");
        const formattedDateFim = moment(rowData.DATAFIM).format("DD/MM/YYYY");
        const updatedRowData = { ...rowData, DATAINICIO: formattedDateInicio, DATAFIM: formattedDateFim };
        setDemand(updatedRowData);
        setDialogDemand(true);
    };

    const authDemandManager = (rowData: any) => {
        setAuthDemand(true);
        setDemand(rowData);
        setDialogDemand(true);
    };

    const actionBodyTemplate = (rowData: Props) => {
        return (
            <React.Fragment>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Tooltip target=".editarDemanda-btn" content="Editar demanda" position="top" />
                    <Button
                        icon='pi pi-pencil'
                        className='p-button-rounded p-button-primary editarDemanda-btn'
                        onClick={() => {
                            editProduct(rowData);
                        }}
                    //disabled={rowData.STATUS === 0 || rowData.STATUS === 1} 
                    />
                    <Tooltip target=".imprimirDemanda-btn" content="Imprimir demanda" position="top" />
                    <Button
                        security=''
                        icon='pi pi-print'
                        className='p-button-rounded p-button-info imprimirDemanda-btn'
                        onClick={() => {
                            sendToPrint(rowData);
                            toastPrint.current.show({
                                severity: 'info',
                                summary: 'Fazendo o download do arquivo.',
                                detail: 'Aguarde...',
                                life: 5000,
                            });
                        }}
                        disabled={rowData.STATUS !== 0}
                    />
                    <Tooltip target=".autorizarDemanda-btn" content="Autorizar demanda" position="top" />
                    <Button
                        security=''
                        icon='pi pi-check'
                        className='p-button-rounded p-button-success autorizarDemanda-btn'
                        onClick={() => authDemandManager(rowData)}
                        disabled={rowData.STATUS === 0 || rowData.STATUS === 1}
                    />
                    <Button
                        security=''
                        icon='pi pi-times'
                        className='p-button-rounded p-button-danger'
                        disabled={rowData.STATUS === 1 || rowData.STATUS === 0}
                        onClick={() => confirmRejectDemand(rowData)}
                    />
                    <Button
                        icon='pi pi-trash'
                        className='p-button-rounded p-button-warning'
                        onClick={() => confirmDeleteProduct(rowData)}
                    //disabled={rowData.STATUS === 0 || rowData.STATUS === 1}
                    />
                </div>
            </React.Fragment>
        );
    };

    const header = (
        <div className='table-header' style={{ display: 'flex', placeContent: 'center' }}>
            <h5 style={{ textAlign: 'center' }} className='p-mx-0 p-my-1'>
                Demandas Recebidas
            </h5>
            {/* <span className='p-input-icon-left'>
				<i className='pi pi-search' />
				<InputText type='search' onInput={e => setGlobalFilter(e)} placeholder='Search...' />
			</span> */}
        </div>
    );

    const deleteProductDialogFooter = (
        <React.Fragment>
            <Button label='Não' icon='pi pi-times' className='p-button-text' onClick={hideDeleteProductDialog} />
            <Button label='Sim' icon='pi pi-check' className='p-button-text' onClick={deleteProduct} />
        </React.Fragment>
    );

    const rejectDemandDialogFooter = (
        <React.Fragment>
            <Button label='Não' icon='pi pi-times' className='p-button-text' onClick={hideRejectDemandDialog} />
            <Button label='Sim' icon='pi pi-check' className='p-button-text' onClick={rejectDemand} />
        </React.Fragment>
    );

    const cellStyle = {
        fontSize: '10px' // Ajuste o tamanho da fonte para as células
    };

    const hearderStyle = {
        fontSize: '6px'
    };



    const onSaldoAbastecimentoChange = (e: CheckboxChangeParams) => {
        setProducts(productsAux);
        let _saldoAbastecimentos: string[] = [...saldoAbastecimentos]; // Garante que é um array de strings

        if (e.checked) {
            _saldoAbastecimentos.push(e.value as string); // Adiciona o valor ao array
        } else {
            _saldoAbastecimentos.splice(_saldoAbastecimentos.indexOf(e.value as string), 1); // Remove o valor do array
        }

        console.log("_saldoAbastecimentos: ", _saldoAbastecimentos);

        setSaldoAbastecimentos(_saldoAbastecimentos);

        // Aplicando os filtros corretamente
        setProducts(
            productsAux?.filter(product => {
                // Se `e.checked` estiver ativo, filtra pela quantidade
                const filtroQuantidade = e.checked ? product.QUANTIDADEEFETIVADA < product.QUANTIDADECOMBUSTIVELSOLICITADO : true;

                // Filtra pelo veículo se um estiver selecionado
                const filtroVeiculo = !selectedVeiculo || product.FT_VEICULO === selectedVeiculo.value;

                return filtroQuantidade && filtroVeiculo;
            }) || []
        );

    };
    return (
        <div className='datatable-crud-demo'>
            <EditDemand />
            <Toast ref={toast} />
            <Toast ref={toastPrint} />
            <div className='card'>
                {/* <Toolbar className='p-mb-4' left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar> */}


                <div className="flex align-items-center">
                    <Checkbox inputId="saldoAbastecimento" name="pizza" value="SemSaldo" onChange={onSaldoAbastecimentoChange}
                        checked={saldoAbastecimentos.includes('SemSaldo')} />
                    <label htmlFor="saldoAbastecimento" className="ml-2">Apenas com Saldo</label>
                </div>


                <div className='p-field p-col-12 p-md-4'>
                    <label htmlFor='descricao'>Veículo</label>
                    <AutoComplete
                        id="vehicle"
                        value={selectedVeiculo}
                        suggestions={filteredVeiculo}
                        completeMethod={searchVeiculo}
                        onSelect={e => {
                            setValueVehicle(e.value.label);
                        }}
                        field="label"
                        dropdown
                        onChange={(e) => {
                            setSelectedVeiculo(e.value)
                        }}
                        placeholder="Selecione a Veículo..."
                    />
                </div>

                <DataTable
                    ref={dt}
                    value={products}
                    selection={selectedProducts}
                    onSelectionChange={e => setSelectedProducts(e.value)}
                    dataKey='id'
                    paginator
                    rows={10}
                    rowsPerPageOptions={[5, 10, 25]}
                    resizableColumns
                    columnResizeMode='fit'
                    showGridlines
                    paginatorTemplate='FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown'
                    currentPageReportTemplate='Exibindo de {first} a {last} de {totalRecords} demandas'
                    globalFilter={globalFilter}
                    header={header}
                    className='p-justify-center'>
                    <Column field='NOME_PESSOADESTINO' header='Solicitantes' style={{ width: '20vh' }} bodyStyle={cellStyle}></Column>
                    {/* <Column field='image' header='Image' body={imageBodyTemplate}></Column> */}
                    <Column
                        field='TIPODEMANDA'
                        header='Tipo de Solicitação'
                        body={typeOfDemandaBodyTemplate}
                        style={{ width: '9vh' }} bodyStyle={cellStyle}

                    ></Column>
                    <Column field='DESCRICAO_PRIORIDADE' header='Prioridade' style={{ width: '9vh' }} bodyStyle={cellStyle}></Column>
                    <Column field='POSTONOME' header='Posto' style={{ width: '9vh' }} bodyStyle={cellStyle}></Column>
                    <Column field='DESCRICAO' header='Descrição' style={{ width: '13vh' }} bodyStyle={cellStyle}></Column>

                    <Column field='NOME_VEICULO' header='Veículo' style={{ width: '11vh' }} bodyStyle={cellStyle}></Column>
                    <Column field='PLACA_VEICULO' header='Placa' style={{ width: '9vh' }} bodyStyle={cellStyle}></Column>
                    <Column field='QUANTIDADECOMBUSTIVELSOLICITADO' header='Qtd Autorizado' style={{ width: '9vh' }} bodyStyle={cellStyle}></Column>
                    <Column field='QUANTIDADEEFETIVADA' header='Qtd Abastecido' style={{ width: '9vh' }} bodyStyle={cellStyle}></Column>
                    <Column body={dateInicioBodyTemplate} header='Data da Início' style={{ width: '9vh' }} bodyStyle={cellStyle}></Column>
                    <Column body={dateFimBodyTemplate} header='Data da Fim' style={{ width: '9vh' }} bodyStyle={cellStyle}></Column>
                    <Column body={dateBodyTemplate} header='Data da Solicitação' style={{ width: '9vh' }} bodyStyle={cellStyle}></Column>

                    <Column
                        header='Status'
                        // filter
                        // filterElement={
                        // 	<Dropdown className='p-column-filter' options={statuses} placeholder='Filtrar' showClear />
                        // }
                        body={statusBodyTemplate}
                        style={{ width: '10vh' }} bodyStyle={cellStyle}></Column>
                    <Column body={actionBodyTemplate} exportable={false} style={{ width: '10rem' }}></Column>
                </DataTable>
            </div>
            <Dialog
                visible={rejectDemandDialog}
                style={{ width: '450px' }}
                header='Rejeitar demanda'
                modal
                focusOnShow={true}
                ariaCloseIconLabel='Fechar'
                baseZIndex={10000}
                draggable
                closeOnEscape
                footer={rejectDemandDialogFooter}
                onHide={hideRejectDemandDialog}>
                <div className='confirmation-content'>
                    <i className='pi pi-exclamation-triangle p-mr-3' style={{ fontSize: '2rem' }} />
                    {product && (
                        <span>
                            Você deseja rejeitar a demanda de <b>{product.NOME_PESSOAORIGEM}</b>?
                        </span>
                    )}
                </div>
            </Dialog>
            <Dialog
                visible={deleteProductDialog}
                style={{ width: '450px' }}
                header='Exclusão de Demanda'
                modal
                focusOnShow={true}
                ariaCloseIconLabel='Fechar'
                baseZIndex={10000}
                draggable
                closeOnEscape
                footer={deleteProductDialogFooter}
                onHide={hideDeleteProductDialog}>
                <div className='confirmation-content'>
                    <i className='pi pi-exclamation-triangle p-mr-3' style={{ fontSize: '2rem' }} />
                    {product && (
                        <span>
                            Você deseja deletar a solicitação de ...<b>{product.NOME_ORGAOUNIDADEDESTINO}</b>?
                        </span>
                    )}
                </div>
            </Dialog>
        </div>
    );
};

export default ReceivedDemandsList;
